<template>
  <div id="about" class="col-4 mx-auto float-left">
    <div id="header">
      <h1 class="col-4 mx-auto text-center">{{ header }}</h1>
      <h2 class="col-4 mx-auto text-center">{{ tagline }}</h2>
    </div>
    <p>
      Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nunc purus tellus auctor in vehicula dictum fames metus. Sagittis pellentesque natoque 
      nibh elementum, aenean sed. Risus enim lobortis nullam vulputate enim. Sagittis lacinia egestas dignissim aliquam dignissim.
      Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nunc purus tellus auctor in vehicula dictum fames metus. Sagittis pellentesque natoque 
      nibh elementum, aenean sed. Risus enim lobortis nullam vulputate enim. Sagittis lacinia egestas dignissim aliquam dignissim.
      Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nunc purus tellus auctor in vehicula dictum fames metus. Sagittis pellentesque natoque 
      nibh elementum, aenean sed. Risus enim lobortis nullam vulputate enim. Sagittis lacinia egestas dignissim aliquam dignissim.
      Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nunc purus tellus auctor in vehicula dictum fames metus. Sagittis pellentesque natoque 
      nibh elementum, aenean sed. Risus enim lobortis nullam vulputate enim. Sagittis lacinia egestas dignissim aliquam dignissim.
      Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nunc purus tellus auctor in vehicula dictum fames metus. Sagittis pellentesque natoque 
      nibh elementum, aenean sed. Risus enim lobortis nullam vulputate enim. Sagittis lacinia egestas dignissim aliquam dignissim.
      Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nunc purus tellus auctor in vehicula dictum fames metus. Sagittis pellentesque natoque 
      nibh elementum, aenean sed. Risus enim lobortis nullam vulputate enim. Sagittis lacinia egestas dignissim aliquam dignissim.
    </p>
  </div>
</template>
<script>
export default {
  name: 'Header',
  el: "#header",
  data: function (){
    return{
      header: "Level Up",
      tagline: "Career Conference",
    };
  }
}
</script>